<template>
  <div class="home-module-config-edit">
    <el-form ref="form" :model="form" size="small">
      <div>
        <el-form-item label="位置1" prop="bannerOne" class="cotent-wrap">
          <div style="margin-top:30px;">
            <template v-for="(item,index) in form.bannerOne">
              <div :key="index" class="card">
                <div v-if="form.bannerOne.length && form.bannerOne.length === 2"><i class="el-icon-remove-outline" @click="remove('bannerOne',index)" /></div>
                <div class="index">序号&emsp;{{ index+1 }}</div>
                <div class="title">标题</div>
                <el-input v-model="item.title" maxlength="10" class="common-input" placeholder="请输入标题，最多10个字" />
                <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'homeModule/'" size-tips="686*240" @upload="oneUp($event,index)" />
                <div class="title" style="margin-left:150px;">链接地址</div>
                <el-input v-model="item.linkUrl" class="common-input underline" placeholder="请填写跳转地址链接" />
              </div>
            </template>
          </div>
          <div v-if="form.bannerOne.length && form.bannerOne.length ===1" class="add-btns" @click="add('bannerOne')"><i class="el-icon-plus">新增配置区</i></div>
        </el-form-item>
        <el-form-item label="位置2" class="cotent-wrap">
          <img src="@/assets/images/hotClass.png" alt="" style="margin-top:30px;">
        </el-form-item>
      </div>
      <div class="marginTop">
        <el-form-item label="位置3" prop="bannerThree" class="cotent-wrap">
          <div style="margin-top:30px;">
            <template v-for="(item,index) in form.bannerThree">
              <div :key="index" class="card">
                <div v-if="form.bannerThree.length && form.bannerThree.length === 2"><i class="el-icon-remove-outline" @click="remove('bannerThree',index)" /></div>
                <div class="index">序号&emsp;{{ index+1 }}</div>
                <div class="title">标题</div>
                <el-input v-model="item.title" maxlength="10" class="common-input" placeholder="请输入标题，最多10个字" />
                <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'homeModule/'" size-tips="686*240" @upload="threeUp($event,index)" />
                <div class="title" style="margin-left:150px;">链接地址</div>
                <el-input v-model="item.linkUrl" class="common-input underline" placeholder="请填写跳转地址链接" />
              </div>
            </template>
          </div>
          <div v-if="form.bannerThree.length && form.bannerThree.length ===1" class="add-btns" @click="add('bannerThree')"><i class="el-icon-plus">新增配置区</i></div>
        </el-form-item>
        <el-form-item style="width:100%">
          <div class="flex btns">
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
  </div>
</template>
<script>
import { HModule } from '@/model/HModule';
import { getHModuleConfig, postHModuleConfig } from '@/api/mpConfiguration';
import UploadImage from './uploadImage.vue';
import FunctionUtils from "@/utils/functionUtils";
import Dialog from '@/components/Dialog';
export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      form: new HModule(),
      formDialogShow: false,
      information: {},
      current: -1,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      getHModuleConfig().then(res => {
        this.form = new HModule(res);
      });
    },
    oneUp(file, index) {
      const list = FunctionUtils.deepClone(this.form.bannerOne);
      list[index].imageUrl = file;
      this.form.bannerOne = list;
    },
    threeUp(file, index) {
      const list = FunctionUtils.deepClone(this.form.bannerThree);
      list[index].imageUrl = file;
      this.form.bannerThree = list;
    },
    remove(type, index) {
      this.information = {
        operation: type,
        icon: 'warn',
        subTitle: `是否删除序号${index + 1}的配置？`,
      };
      this.current = index;
      this.formDialogShow = true;
    },
    submit() {
      const param = this.dealForm();
      postHModuleConfig(param).then(res => {
        this.$message.success('保存成功');
        this.fetchData();
      });
    },
    dealForm() {
      const copyForm = FunctionUtils.deepClone(this.form);
      Object.keys(copyForm).forEach(key => {
        copyForm[key].forEach((item, index) => {
          const list = Object.values(item);
          const len = list.filter(item => item === '').length;
          if (len === 1 || len === 2) {
            this.$message.warning(`请补全位置${key === 'bannerOne' ? '位置1' : '位置3'}～序号${index + 1}的信息`);
            throw new Error('校验未通过');
          }
          if (len === 3) {
            copyForm[key].splice(index, 1);
          }
        });
      });
      return copyForm;
    },
    add(type) {
      this.form[type].push({
        imageUrl: "", linkUrl: "", title: "",
      });
    },
    submitSuccess(type) {
      const list = FunctionUtils.deepClone(this.form[type]);
      list.splice(this.current, 1);
      this.form[type] = list;
      this.current = -1;
    },
  },
};
</script>

<style lang="less" scoped>
.home-module-config-edit {
  padding: 30px;
  background: #fff;
  .add-btns {
    display: inline-block;
    border: 1px dashed #bbbbbb;
    color: #bbbbbb;
    padding: 0px 20px;
    border-radius: 6px;
    cursor: pointer;
  }
  .btns {
    display: flex;
    justify-content: center;
    .el-button {
      width: 120px;
      height: 50px;
    }
  }
  :deep(.el-form-item__label) {
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: #000000;
  }
  :deep(.cotent-wrap) {
    .el-form-item__label {
      float: none;
    }
    .common-input {
      width: 360px;
      margin-right: 60px;
      &.underline {
        .el-input__inner {
          text-decoration: underline;
        }
      }
      .el-input__inner {
        background: #f7f7f7;
        color: #494949;
      }
    }
  }

  .card {
    width: 100%;
    height: 222px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    padding: 0 40px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
    .el-icon-remove-outline {
      font-size: 30px;
      color: #bbbbbb;
      line-height: 32px;
      margin-right: 58px;
      &:hover {
        cursor: pointer;
        color: #000;
      }
    }

    .index {
      margin-right: 70px;
      white-space: nowrap;
    }
    .title {
      margin-right: 10px;
      white-space: nowrap;
    }
    &.card {
      margin-bottom: 30px;
    }
  }
}
</style>
